<template>
    <router-link :to="{path:basePath+'/'+id+'_'+title.replace(/[^\w ]/, '').replace(/ /g, '+')}">
    <v-card class="title-tile float-left mx-2" max-width="320" >
        <v-img
                class="white--text align-end title-image"
                height="auto"
                :src="image"
        >
        </v-img>

        <v-card-text class="title-title text--primary">{{title}}</v-card-text>
        <v-card-text class="title-title star-container">
             <span v-if="seasons" class="d-block">
                 Seasons {{seasons}}
            </span>
            <span class="title-year d-inline-block">
                {{year}}
            </span>

            <span class="title-year d-inline-block float-right">
                 <v-rating
                           v-model="rating"
                           half-increments
                           background-color="red"
                           :dense=true
                           full-icon="fa-star"
                           color="red"
                           readonly
                           x-small
                           half-icon="fa-star-half-alt"
                 ></v-rating>
            </span>

        </v-card-text>
    </v-card>
    </router-link>
</template>
<style>
    .title-title{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
        padding: 3px 10px !important;
        line-height: 1;
    }
    .star-container{
        margin-bottom: 10px;
    }
    .title-tile{
        transition: all .1s ease-in-out;
        margin-bottom: 15px;
    }
    .title-tile:hover {
        transform: scale(1.02);
    }
    .title-title{
        width: 320px !important;
    }
    .title-image{
        width: 320px !important;
        height: 480px !important;
    }
    @media(min-width: 768px){
        .title-title{
            width: 200px !important;
        }
        .title-image{
            width: 200px !important;
            height: 300px !important;
        }
    }
    .title-year{
        margin-right: 10px;
        margin-top: 2px;
    }
</style>
<script>
    export default {
        props: ['id','image','title','year','rating','basePath','seasons']
    }
</script>